import { useCallback } from 'react';

import { TDelRoutePoint } from '../types/delRoutePoint';
import { TSetRoutePoints } from '../types/setRoutePoints';

const useDelRoutePoint = (setRoutePoints: TSetRoutePoints) => {
  const onDelRoutePoint: TDelRoutePoint = useCallback(
    (id) => {
      setRoutePoints((prevPoints) =>
        prevPoints.filter((point) => point.id !== id),
      );
    },
    [setRoutePoints],
  );

  return onDelRoutePoint;
};

export default useDelRoutePoint;
